// Простой клиент аутентификации: JWT в localStorage + axios-инстанс для /api/auth
import axios from 'axios';

const TOKEN_KEY = 'kladoffka24:token';
const API_BASE = process.env.REACT_APP_BACKEND_URL ?? '';

export function getToken() {
  try { return localStorage.getItem(TOKEN_KEY) || null; } catch { return null; }
}
export function setToken(t) {
  try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch {}
}
export function clearToken() { setToken(null); }

// axios с автоматическим Authorization
export const authAxios = axios.create({ baseURL: API_BASE });
authAxios.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers = { ...(cfg.headers || {}), Authorization: `Bearer ${t}` };
  return cfg;
});

export async function login(phone, password) {
  const { data } = await authAxios.post('/api/auth/login', { phone, password });
  if (data?.token) setToken(data.token);
  return data;
}

export async function me() {
  const { data } = await authAxios.get('/api/auth/me');
  return data;
}

export async function logout() {
  try { await authAxios.post('/api/auth/logout'); } catch {}
  clearToken();
}

export async function register(formData /* FormData с файлом */) {
  const { data } = await authAxios.post('/api/auth/register', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  if (data?.token) setToken(data.token);
  return data;
}
